import React, { useState } from 'react';
import { DropdownButton } from 'react-bootstrap';
import { DeleteBlueIcon } from '../icons/DeleteBlueIcon.jsx';
import { GenerateIcon } from '../icons/GenerateIcon.jsx';
import { EditBlueIcon } from '../icons/EditBlueIcon.jsx';
import CustomMenuItem from '../CustomMenuItem.jsx';

const ChangeInsightsAnalysisActionDropdown = ({
  loading,
  onDeleteAnalysis,
  onRegenerate,
  onEdit,
  hasError,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = (newState) => {
    setIsOpen(newState);
  };

  const handleMenuClick = (callback) => () => {
    setIsOpen(false);
    if (callback) {
      callback();
    }
  };

  return (
    <div className="actions">
      <DropdownButton
        noCaret
        className="btn-more btn btn-default"
        open={isOpen}
        onToggle={handleToggle}
      >
        {!hasError ? (
          <>
            <CustomMenuItem
              disabled={loading}
              onClick={handleMenuClick(onRegenerate)}
            >
              <span className="flex">
                <GenerateIcon />
                <span>&nbsp; Re-generate Analysis</span>
              </span>
            </CustomMenuItem>
            <CustomMenuItem divider />
          </>
        ) : null}

        <CustomMenuItem disabled={loading} onClick={handleMenuClick(onEdit)}>
          <span className="flex">
            <EditBlueIcon />
            <span>&nbsp; Edit</span>
          </span>
        </CustomMenuItem>
        <CustomMenuItem divider />

        <CustomMenuItem
          onClick={handleMenuClick(onDeleteAnalysis)}
          disabled={loading}
        >
          <span className="flex">
            <DeleteBlueIcon />
            <span>&nbsp; Delete</span>
          </span>
        </CustomMenuItem>
        <CustomMenuItem divider />
      </DropdownButton>
    </div>
  );
};

export default ChangeInsightsAnalysisActionDropdown;
